function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === 'undefined' || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') {
            if (it)
                o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length)
                        return { done: true };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it['return'] != null)
                    it['return']();
            } finally {
                if (didErr)
                    throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module heading/headingui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import {
    createDropdown,
    addListToDropdown
} from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import { getLocalizedOptions } from './utils';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import '../theme/heading.css';
/**
 * The headings UI feature. It introduces the `headings` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */
var HeadingUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(HeadingUI, _Plugin);
    var _super = _createSuper(HeadingUI);
    function HeadingUI() {
        _classCallCheck(this, HeadingUI);
        return _super.apply(this, arguments);
    }
    _createClass(HeadingUI, [{
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var _this = this;
                var editor = this.editor;
                var t = editor.t;
                var options = getLocalizedOptions(editor);
                var defaultTitle = t('Choose heading');
                var dropdownTooltip = t('Heading');
                // Register UI component.
                editor.ui.componentFactory.add('heading', function (locale) {
                    var titles = {};
                    var itemDefinitions = new Collection();
                    var headingCommand = editor.commands.get('heading');
                    var paragraphCommand = editor.commands.get('paragraph');
                    var commands = [headingCommand];
                    var _iterator = _createForOfIteratorHelper(options), _step;
                    try {
                        var _loop = function _loop() {
                            var option = _step.value;
                            var def = {
                                type: 'button',
                                model: new Model({
                                    label: option.title,
                                    'class': option['class'],
                                    withText: true
                                })
                            };
                            if (option.model === 'paragraph') {
                                def.model.bind('isOn').to(paragraphCommand, 'value');
                                def.model.set('commandName', 'paragraph');
                                commands.push(paragraphCommand);
                            } else {
                                def.model.bind('isOn').to(headingCommand, 'value', function (value) {
                                    return value === option.model;
                                });
                                def.model.set({
                                    commandName: 'heading',
                                    commandValue: option.model
                                });
                            }
                            // Add the option to the collection.
                            itemDefinitions.add(def);
                            titles[option.model] = option.title;
                        };
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            _loop();
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally {
                        _iterator.f();
                    }
                    var dropdownView = createDropdown(locale);
                    addListToDropdown(dropdownView, itemDefinitions);
                    dropdownView.buttonView.set({
                        isOn: false,
                        withText: true,
                        tooltip: dropdownTooltip
                    });
                    dropdownView.extendTemplate({ attributes: { 'class': ['ck-heading-dropdown'] } });
                    dropdownView.bind('isEnabled').toMany(commands, 'isEnabled', function () {
                        for (var _len = arguments.length, areEnabled = new Array(_len), _key = 0; _key < _len; _key++) {
                            areEnabled[_key] = arguments[_key];
                        }
                        return areEnabled.some(function (isEnabled) {
                            return isEnabled;
                        });
                    });
                    dropdownView.buttonView.bind('label').to(headingCommand, 'value', paragraphCommand, 'value', function (value, para) {
                        var whichModel = value || para && 'paragraph';
                        // If none of the commands is active, display default title.
                        return titles[whichModel] ? titles[whichModel] : defaultTitle;
                    });
                    // Execute command when an item from the dropdown is selected.
                    _this.listenTo(dropdownView, 'execute', function (evt) {
                        editor.execute(evt.source.commandName, evt.source.commandValue ? { value: evt.source.commandValue } : undefined);
                        editor.editing.view.focus();
                    });
                    return dropdownView;
                });
            }
        }]);
    return HeadingUI;
}(Plugin);
export {
    HeadingUI as default
};